import React from "react";
import {
  ButtonCollapse,
  ButtonDownload,
  ButtonCopy,
  ButtonRetry,
  ButtonTerminalSimulation,
  ButtonAssignTagsToResources,
} from "src/components/Common/Button";
import ThreeDofTable from "src/components/Common/Table/ThreeDofTable";
import SixDofTable from "src/components/Common/Table/SixDofTable";
import ShowDataCell from "src/components/Common/DataCell";
import SimulationMCSDashboard from "src/components/Common/Dropdown/SimulationMCSDashboard";
import SimulationMultiDashboard from "src/components/Common/Dropdown/SimulationMultiDashboard";
import Simulation6DofDashboard from "src/components/Common/Dropdown/Simulation6DofDashboard";
import Simulation6DofMCSDashboard from "src/components/Common/Dropdown/Simulation6DofMCSDashboard";
import ProtectedComponent from "src/components/Permission";
import CustomFilterButton from "src/components/Common/CustomFilterButton";
import { EXECUTION_FILE_TYPE, PROCESS_STATUS, SIMULATION_RESULT, SIMULATION_TYPE, SIMULATION_TYPE_OPTIONS } from "src/constant/common";
import LabelStatus from "src/components/Common/LabelStatus";
import ModalEditSimulation from "src/components/Common/Modal/ModalEditSimulation";

const LabelStatusWithErrorDetails = ({ row }) => {
  return <LabelStatus row={row} />;
};

export const columns = ({
  t,
  onClickCollapsed,
  seriesById,
  setDataModalFileView,
  setSeriesById,
  handleFilterData,
  params,
  versionOptions,
  excutionFileOptions,
  userOptions,
  allTagsData,
  isShowDashboardButton,
  dashboardLoading,
  setDashboardLoading,
  refetch,
  handleTerminationSimulation,
  handleOpenAssignTagsModal,
}) => [
  {
    dataField: "id",
    text: t("list.table.id"),
    // text: (
    //   <div className="d-flex align-items-center gap-1">
    //     <span className="text-nowrap">{t("list.table.id")}</span>
    //     <ButtonAssignTagsToResources
    //       isShow={multiResourcesSelected.length > 1}
    //       id="multi-resources"
    //       handleClick={handleOpenAssignTagsModal}
    //     />
    //   </div>
    // ),
    formatter: (id) => <ShowDataCell data={id} customClass="text-nowrwap" />,
    headerClass: "width-by-percent-10 align-middle text-nowrap",
  },
  {
    dataField: "tags",
    text: (
      <div className="d-flex align-items-center gap-1">
        {t("list.table.tags")}
        <CustomFilterButton
          name="tag_ids"
          className="width-by-px-400 left-30"
          options={allTagsData || []}
          handleApply={handleFilterData}
          defaultValue={params?.tag_ids || ""}
          isSearchable
          isMultiple
          closeMenuOnSelect={false}
        />
      </div>
    ),
    formatter: (tags, row) => (
      <ButtonAssignTagsToResources
        id={`resource-${row?.id}`}
        handleClick={() => handleOpenAssignTagsModal(row?.id)}
        tags={tags || []}
        tooltipText={tags?.map((tag) => tag?.name)?.join(", ") || "no_tags_found"}
      />
    ),
    headerClass: "width-by-percent-6 align-middle text-nowrap",
  },
  {
    dataField: "name",
    text: t("list.table.name"),
    formatter: (name) => <ShowDataCell data={name} customClass="text-nowrwap" />,
    headerClass: "width-by-percent-9 align-middle text-nowrap",
  },
  {
    dataField: "status",
    text: t("list.table.status"),
    headerClass: "width-by-percent-11 align-middle text-nowrap",
    formatter: (_, row) => {
      return <LabelStatusWithErrorDetails row={row} />;
    },
  },
  {
    dataField: "param",
    text: t("list.table.param"),
    headerClass: "width-by-percent-6 align-middle text-nowrap",
    formatter: (_, row, { isCollapse, toggleCollapse }) => (
      <ButtonCollapse handleCollapse={() => toggleCollapse(() => onClickCollapsed(row))} isCollapsed={!isCollapse} />
    ),
    collapseRow: (row) => (
      <>
        <ThreeDofTable
          isShow={row.type === SIMULATION_TYPE["3DOF"]}
          simulationData={row}
          isError={seriesById?.[row?.id]?.error}
          isLoading={seriesById?.[row?.id]?.loading}
          serieData={seriesById?.[row?.id]}
          handleViewFile={setDataModalFileView}
          updateData={setSeriesById}
        />
        <SixDofTable
          isShow={row.type === SIMULATION_TYPE["6DOF"] || row.type === SIMULATION_TYPE["6DOF_MCS"]}
          simulationData={row}
          isError={seriesById?.[row?.id]?.error}
          isLoading={seriesById?.[row?.id]?.loading}
          serieData={seriesById?.[row?.id]}
          handleViewFile={setDataModalFileView}
          updateData={setSeriesById}
        />
      </>
    ),
  },
  {
    dataField: "type",
    text: (
      <div className="d-flex align-items-center gap-1">
        {t("list.table.type")}
        <CustomFilterButton
          name="type"
          className="width-by-px-300"
          options={Object.keys(SIMULATION_TYPE_OPTIONS).map((key) => ({
            label: SIMULATION_TYPE_OPTIONS[key],
            value: SIMULATION_TYPE_OPTIONS[key],
          }))}
          handleApply={handleFilterData}
          defaultValue={params?.type || ""}
          isSearchable
          isMultiple
          closeMenuOnSelect={false}
        />
      </div>
    ),
    headerClass: "width-by-percent-6 align-middle text-nowrap",
  },
  {
    dataField: "version_name",
    text: (
      <div className="d-flex align-items-center gap-1">
        {t("list.table.version")}
        <CustomFilterButton
          name="version_name"
          className="width-by-px-520"
          options={versionOptions}
          handleApply={handleFilterData}
          defaultValue={params?.version_name || ""}
          isSearchable
          isMultiple
          closeMenuOnSelect={false}
        />
      </div>
    ),
    headerClass: "width-by-percent-7 align-middle text-nowrap",
  },
  {
    dataField: "execution_file_name",
    text: (
      <div className="d-flex align-items-center gap-1">
        {t("list.table.execution_file")}
        <CustomFilterButton
          name="execution_file_name"
          className="width-by-px-450"
          options={excutionFileOptions}
          handleApply={handleFilterData}
          defaultValue={params?.execution_file_name || ""}
          isSearchable
          isMultiple
          closeMenuOnSelect={false}
        />
      </div>
    ),
    headerClass: "width-by-percent-11 align-middle text-nowrap",
  },
  {
    dataField: "updated_by",
    text: (
      <div className="d-flex align-items-center gap-1">
        {t("list.table.user")}
        <CustomFilterButton
          name="user_ids"
          className="width-by-px-500"
          options={userOptions}
          handleApply={handleFilterData}
          defaultValue={params?.user_ids || ""}
          isSearchable
          isMultiple
          closeMenuOnSelect={false}
        />
      </div>
    ),
    formatter: (_, row) => <ShowDataCell data={row.updated_by} />,
    headerClass: "width-by-percent-9 align-middle text-nowrap",
  },
  {
    dataField: "updated_at",
    text: t("list.table.update_at"),
    headerClass: "width-by-percent-10 align-middle text-nowrap",
  },
  {
    dataField: "note",
    text: t("list.table.note"),
    formatter: (note) => <ShowDataCell data={note} />,
    headerClass: "width-by-percent-8 align-middle text-nowrap",
  },
  {
    dataField: "dashboard",
    text: "",
    headerClass: "width-by-px-55 important-p-a-10 align-middle text-nowrap",
    rowClass: "text-center important-p-a-10",
    formatter: (_, row) => (
      <>
        <SimulationMCSDashboard isShow={isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.MCS)} simulationData={row} />
        <SimulationMultiDashboard
          isShow={
            isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.MULTI) ||
            isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.PAYLOAD) ||
            isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.SINGLE) ||
            isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.PAYLOAD_SOE_ASSIST) ||
            isShowDashboardButton(row, SIMULATION_TYPE["3DOF"], SIMULATION_RESULT.DEBRIS_IMPACT_ANALYSIS)
          }
          simulation={row}
          setDashboardLoading={setDashboardLoading}
          isLoading={dashboardLoading?.[row.id]}
        />
        <Simulation6DofDashboard
          isShow={
            isShowDashboardButton(row, SIMULATION_TYPE["6DOF"], SIMULATION_RESULT.SIX_DOF) ||
            isShowDashboardButton(row, SIMULATION_TYPE["6DOF"], EXECUTION_FILE_TYPE.DISPERSION_6DOF)
          }
          simulationData={row}
          updateSimulation={refetch}
        />
        <Simulation6DofMCSDashboard
          isShow={isShowDashboardButton(row, SIMULATION_TYPE["6DOF"], EXECUTION_FILE_TYPE.MCS_6DOF)}
          simulationData={row}
        />
      </>
    ),
  },
  {
    dataField: "download",
    text: "",
    headerClass: "width-by-px-55 important-p-a-10 align-middle",
    rowClass: "text-center important-p-a-10",
    formatter: (_, row) => <ButtonDownload url={row.result_link} id={row.id} />,
  },
  {
    dataField: "actions",
    text: "",
    headerClass: "width-by-px-55 important-p-a-10 align-middle",
    rowClass: "text-center important-p-a-10",
    formatter: (_, row) => (
      <>
        <ProtectedComponent id={`action${row.id}`}>
          <ButtonCopy
            id={row.id}
            isShow={row.status === PROCESS_STATUS.SUCCEEDED}
            toUrl={`/flight/${row?.id}?action=copy${params.page ? "&page=" + params.page : ""}${
              params?.condition ? "&condition=" + params.condition : ""
            }${params?.type ? "&type=" + params.type : ""}${params?.version_name ? "&version_name=" + params.version_name : ""}${
              params?.execution_file_name ? "&execution_file_name=" + params.execution_file_name : ""
            }${params?.user_ids ? "&user_ids=" + params.user_ids : ""}${params?.tag_ids ? "&tag_ids=" + params.tag_ids : ""}`}
          />
        </ProtectedComponent>
        <ProtectedComponent id={`retry${row.id}`} ownerId={row.created_by}>
          <ButtonTerminalSimulation
            id={row.id}
            isShow={row.status === PROCESS_STATUS.SUBMITTED || row.status === PROCESS_STATUS.RUNNING}
            handleSubmit={(id, callback) => handleTerminationSimulation(id, callback)}
          />
          <ButtonRetry
            id={row.id}
            isShow={row.status === PROCESS_STATUS.FAILED || row.status === PROCESS_STATUS.TERMINATED}
            toUrl={`/flight/${row?.id}?action=retry${params.page ? "&page=" + params.page : ""}${
              params?.condition ? "&condition=" + params.condition : ""
            }${params?.type ? "&type=" + params.type : ""}${params?.version_name ? "&version_name=" + params.version_name : ""}${
              params?.execution_file_name ? "&execution_file_name=" + params.execution_file_name : ""
            }${params?.user_ids ? "&user_ids=" + params.user_ids : ""}${params?.tag_ids ? "&tag_ids=" + params.tag_ids : ""}`}
          />
        </ProtectedComponent>
      </>
    ),
  },
  {
    dataField: "",
    text: "",
    headerClass: "width-by-px-60 align-middle",
    rowClass: "text-center",
    formatter: (_, row) => (
      <ProtectedComponent id={`edit-${row.id}`} ownerId={row.created_by}>
        <ModalEditSimulation simData={row} onSuccess={() => refetch()} />
      </ProtectedComponent>
    ),
  },
];
